// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

const ControlButtonsSection = ({
  closeModal,
  submit,
}) => {
  const cancel = (event) => {
    event.preventDefault();
    closeModal();
  };

  const handlerSave = async event => {
    event.preventDefault();
    submit('addFundsToDwollaBalanceBySuperAdminReduxForm');
  };

  return (
    <div className="popup_footer">
      <button
        type="button"
        className="dashboard-btn dashboard-btn--secondary"
        aria-label="cancel"
        onClick={cancel}
      >
        Cancel
      </button>
      <button
        type="button"
        className="dashboard-btn dashboard-btn--primary"
        name="save"
        onClick={handlerSave}
      >
        Save
      </button>
    </div>
  );
};

const mapDispatchToProps = {
  submit,
};

export default connect(null, mapDispatchToProps)(ControlButtonsSection);
